// extracted by mini-css-extract-plugin
module.exports = {"b1yvsvix":"b1yvsvix"};